import React, { Component } from 'react'

class FullHeightImageWithText extends Component {
    setBG() {
        const { data } = this.props

        const fixed = data.fixedBG ? 'fixed' : ''
        const colorOverlay = data.colorOverlay === true ? 'linear-gradient(rgba(0,0,0,.5), rgba(0,0,0,.5)), ' : ''

        return `${colorOverlay}url(${data.backgroundImage}) no-repeat center center ${fixed}`
    }

    render() {
        const { data } = this.props

        return (
            <div
                className="full-height-image"
                style={{ ...slideStyle, background: this.setBG() }}
            >
                <div className="container">
                    <div style={{ ...slideContent }} className="slider-content">
                        <h1 className="slider-title">{data.content.title}</h1>
                        {data.content.subtitle && <h3 className="text-white">{data.content.subtitle}</h3>}
                        <p style={{ ...contentP }} className="slider-text" dangerouslySetInnerHTML={{ __html: data.content.text }}></p>
                    </div>
                </div>
            </div>
        )
    }
}

const slideStyle = {
    backgroundReapeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    // eslint-disable-next-line
    display: '-webkit-box',
    // eslint-disable-next-line
    display: '-moz-box',
    // eslint-disable-next-line
    display: '-ms-flexbox',
    // eslint-disable-next-line
    display: '-webkit-flex',
    // eslint-disable-next-line
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
}

const slideContent = {
    padding: '20px 80px',
    textAlign: 'center'
}

const contentP = {
    fontSize: '1.2em',
    margin: 0
}

export { FullHeightImageWithText }


// WEBPACK FOOTER //
// ./src/components/sections/FullHeightImageWithText.js